/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  HeightRequest,
  HeightResponse,
  TzResponse,
  TzResponseV2,
} from "../models/index";
import {
  HeightRequestFromJSON,
  HeightRequestToJSON,
  HeightResponseFromJSON,
  HeightResponseToJSON,
  TzResponseFromJSON,
  TzResponseToJSON,
  TzResponseV2FromJSON,
  TzResponseV2ToJSON,
} from "../models/index";

export interface ElevationRequest {
  heightRequest: HeightRequest;
}

export interface TzLookupRequest {
  lat: number;
  lng: number;
  timestamp?: number;
}

export interface TzLookupV2Request {
  lat: number;
  lng: number;
  timestamp?: number;
}

/**
 *
 */
export class GeospatialApi extends runtime.BaseAPI {
  /**
   * Creates request options for elevation without sending the request
   */
  async elevationRequestOpts(
    requestParameters: ElevationRequest,
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["heightRequest"] == null) {
      throw new runtime.RequiredError(
        "heightRequest",
        'Required parameter "heightRequest" was null or undefined when calling elevation().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      queryParameters["api_key"] = await this.configuration.apiKey("api_key"); // ApiKeyAuth authentication
    }

    let urlPath = `/elevation/v1`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: HeightRequestToJSON(requestParameters["heightRequest"]),
    };
  }

  /**
   * The Stadia elevation API allows you to get the elevation of any point on earth. You can pass either a simple set of points or a Google encoded polyline string. This pairs well with our routing APIs, so you can generate an elevation profile for your next bike or run.
   * Get the elevation profile along a polyline or at a point.
   */
  async elevationRaw(
    requestParameters: ElevationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HeightResponse>> {
    const requestOptions = await this.elevationRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      HeightResponseFromJSON(jsonValue),
    );
  }

  /**
   * The Stadia elevation API allows you to get the elevation of any point on earth. You can pass either a simple set of points or a Google encoded polyline string. This pairs well with our routing APIs, so you can generate an elevation profile for your next bike or run.
   * Get the elevation profile along a polyline or at a point.
   */
  async elevation(
    requestParameters: ElevationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HeightResponse> {
    const response = await this.elevationRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tzLookup without sending the request
   */
  async tzLookupRequestOpts(
    requestParameters: TzLookupRequest,
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["lat"] == null) {
      throw new runtime.RequiredError(
        "lat",
        'Required parameter "lat" was null or undefined when calling tzLookup().',
      );
    }

    if (requestParameters["lng"] == null) {
      throw new runtime.RequiredError(
        "lng",
        'Required parameter "lng" was null or undefined when calling tzLookup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["lat"] != null) {
      queryParameters["lat"] = requestParameters["lat"];
    }

    if (requestParameters["lng"] != null) {
      queryParameters["lng"] = requestParameters["lng"];
    }

    if (requestParameters["timestamp"] != null) {
      queryParameters["timestamp"] = requestParameters["timestamp"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      queryParameters["api_key"] = await this.configuration.apiKey("api_key"); // ApiKeyAuth authentication
    }

    let urlPath = `/tz/lookup/v1`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve the time zone identifier, standard UTC offset, special offset (such as DST), and the localized time in several common formats.
   * Get time zone information for any point on earth.
   */
  async tzLookupRaw(
    requestParameters: TzLookupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TzResponse>> {
    const requestOptions = await this.tzLookupRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TzResponseFromJSON(jsonValue),
    );
  }

  /**
   * Retrieve the time zone identifier, standard UTC offset, special offset (such as DST), and the localized time in several common formats.
   * Get time zone information for any point on earth.
   */
  async tzLookup(
    requestParameters: TzLookupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TzResponse> {
    const response = await this.tzLookupRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tzLookupV2 without sending the request
   */
  async tzLookupV2RequestOpts(
    requestParameters: TzLookupV2Request,
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["lat"] == null) {
      throw new runtime.RequiredError(
        "lat",
        'Required parameter "lat" was null or undefined when calling tzLookupV2().',
      );
    }

    if (requestParameters["lng"] == null) {
      throw new runtime.RequiredError(
        "lng",
        'Required parameter "lng" was null or undefined when calling tzLookupV2().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["lat"] != null) {
      queryParameters["lat"] = requestParameters["lat"];
    }

    if (requestParameters["lng"] != null) {
      queryParameters["lng"] = requestParameters["lng"];
    }

    if (requestParameters["timestamp"] != null) {
      queryParameters["timestamp"] = requestParameters["timestamp"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      queryParameters["api_key"] = await this.configuration.apiKey("api_key"); // ApiKeyAuth authentication
    }

    let urlPath = `/tz/lookup/v2`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve the time zone identifier, total UTC offset, whether DST is in effect, and the localized time in several common formats.
   * Get time zone information for any point on earth.
   */
  async tzLookupV2Raw(
    requestParameters: TzLookupV2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TzResponseV2>> {
    const requestOptions = await this.tzLookupV2RequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TzResponseV2FromJSON(jsonValue),
    );
  }

  /**
   * Retrieve the time zone identifier, total UTC offset, whether DST is in effect, and the localized time in several common formats.
   * Get time zone information for any point on earth.
   */
  async tzLookupV2(
    requestParameters: TzLookupV2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TzResponseV2> {
    const response = await this.tzLookupV2Raw(requestParameters, initOverrides);
    return await response.value();
  }
}
